
export default {
	name: "InputField",
	model: {
		prop: "value",
		event: "input",
	},
	props: {
		value: {
			required: true,
			type: [String, Number],
		},
		stepperStyle: {
			required: false,
			type: Boolean,
			default: false,
		},
		block: {
			required: false,
			type: Boolean,
			default: false,
		},
		valueMiddleware: {
			required: false,
			type: Function,
			default: (v) => v,
		},
		id: {
			required: false,
			type: String,
			default: null,
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			localValue: this.value,
		};
	},
	watch: {
		value(newVal) {
			this.localValue = newVal;
		},
	},
	methods: {
		onBlur() {
			if (this.stepperStyle) {
				this.updateValue();
			}
		},
		onInput() {
			if (!this.stepperStyle) {
				this.updateValue();
			}
		},
		async updateValue() {
			const input = this.$refs.input;
			// Save cursor position before any async work or DOM writes.
			const start = input.selectionStart;
			const end = input.selectionEnd;
			let val = this.$el.value;
			const originalLength = val.length;
			val =
				typeof this.valueMiddleware === "function"
					? this.valueMiddleware(val)
					: val;

			this.$emit("input", val);
			await this.$nextTick();
			// Setting .value always moves cursor to end, even when the value is
			// unchanged. Restore the saved position, adjusted for any characters
			// removed by the middleware (e.g. filtering invalid chars).
			this.$el.value = val;
			const diff = originalLength - val.length;
			input.setSelectionRange(
				Math.max(0, start - diff),
				Math.max(0, end - diff)
			);
		},
	},
};
